// HTTP helpers for the PESTEL backend.
//
// The PESTEL backend lives under `${backendUrl}/api/...`. We deliberately do
// NOT use `Config.network.apiUrl` (which points at the legacy `/api/v1/` regul
// API), so that PESTEL endpoints work even if the legacy config is wrong.
import axios from 'axios'
import Config from 'config'

const { backendUrl } = Config.network

export const pestelApiUrl = (path) => `${backendUrl}/api${path.startsWith('/') ? path : `/${path}`}`

export function setAuthHeader(token) {
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`
  } else {
    delete axios.defaults.headers.common.Authorization
  }
}

export function pestelLogin(email, password) {
  return axios.post(pestelApiUrl('/auth/login'), { email, password })
}

export function pestelMe() {
  return axios.get(pestelApiUrl('/auth/me'))
}

// Read-only roster. PESTEL accounts are created and their permissions set by
// RegulApp (Settings -> PESTEL Access), so there are no write helpers here.
export function listUsers() {
  return axios.get(pestelApiUrl('/users'))
}

// Workspaces the logged-in PESTEL user belongs to (drives the sidebar switcher).
export function listMyWorkspaces() {
  return axios.get(pestelApiUrl('/my/workspaces'))
}
